import { Component } from "react";
import LoginHeaderOperational from './LoginHeaderOperational';
import Sidebar_Progress from "../layouts/Operational_Sidebar_Progress.component";
import { API_URL } from "../../constant/API_Settings";
import React, { useMemo, useState } from 'react';
import swal from "sweetalert";
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import { Link } from "react-router-dom";
import logo from '../../img/logo.svg';
import jsPDF from "jspdf";
import "jspdf-autotable";
import html2canvas from 'html2canvas';
import { FuelLabel, getFuelLabelClass } from '../../utils/fuelLabelColor';
import { buildFuelSalesTableRows } from '../../utils/dailyTransactionFuelSalesRows';
import { buildPackedOilSalesTableRows } from '../../utils/dailyTransactionPackedOilSalesRows';
import {
  buildCylinderSalesTableRows,
  buildOilBarrelSalesTableRows,
  buildCreditSalesTableRows,
  buildRecoupTableRows,
  buildExpenseVoucherTableRows,
  buildDigitalPaymentTableRows,
  buildShortExcessTableRows,
  computeShortExcessGrandTotal,
} from '../../utils/dailyTransactionSectionRows';
import { NumTd, NumTh } from '../../utils/reportDisplay';
import DailyTransactionWacPanel from './DailyTransactionWacPanel';
import {
  OtherReportFilterCard,
  OtherReportToolbar,
  ReportDateRangeFields,
  ReportSubmitButton,
} from './other-reports/OtherReportShared';
import '../operational-model/other-reports/other-reports.css';
import '../operational-model/other-reports/report-table.css';
import './daily-transaction-sheet.css';

const DailyTransactionSheet = (props) => {

  const [opening_balance, setOpeningBalance] = useState([])
  const [opening_balance_dr_cr, setOpeningBalanceDrCr] = useState({})

  const [inputValues, setInputValues] = useState({})

  const [fule_sale, setFuleSale] = useState([])
  const [fule_sale_sum, setFuleSaleSum] = useState([])
  const [fule_sale_outstanding, setFuleSaleOutstanding] = useState([])

  const [Loose_oil, setLooseOil] = useState([])
  const [Loose_oil_sum, setLooseOilSum] = useState([])
  const [Loose_oil__outstanding, setLooseOilOutstanding] = useState([])

  const [paked_oil, setPakedOil] = useState([])
  const [paked_oil_sum, setPakedOilSum] = useState([])
  const [paked_oil_outstanding, setPakedOilOutstanding] = useState([])

  const [cylinder_sales, setCylinderSales] = useState([])
  const [cylinder_sales_sum, setCylinderSalesSum] = useState(0)
  const [cylinder_sales_outstanding, setCylinderSalesOutstanding] = useState(0)

  const [los_sales, setLosSales] = useState([])
  const [los_sales_sum, setLosSalesSum] = useState(0)
  const [los_sales_outstanding, setLosSalesOutstanding] = useState(0)

  const [reciept, setReciept] = useState([])
  const [reciept_transfer, setRecieptTransfer] = useState([])
  const [reciept_salary, setRecieptSalary] = useState([])
  const [receipt_sum, setReceiptSum] = useState([])
  const [reciept_outstanding, setRecieptOutstanding] = useState([])

  const [other_income, setOtherIncome] = useState([])
  const [other_income_sum, setOtherIncomeSum] = useState([])
  const [other_income_outstanding, setOtherIncomeOutstanding] = useState([])

  const [credit_sales, setCreditsales] = useState([])
  const [credit_sales_sum, setCreditSalesSum] = useState([])
  const [credit_sales_outstanding, setCreditsalesOutstanding] = useState([])

  const [recoup, setRecoup] = useState([])
  const [recoup_sum, setRecoupSum] = useState([])
  const [recoup_outstanding, setRecoupOutsatanding] = useState([])

  const [mla_sales, setMLASales] = useState([])
  const [mla_sales_sum, setMLASalesSum] = useState([])
  const [mla_sales_outstanding, setMLASalesOutstanding] = useState([])

  const [fleet_sales, setFleetales] = useState([])
  const [fleet_sales_sum, setFleetSalesSum] = useState([])
  const [fleet_sales_outstanding, setFleetalesOutstanding] = useState([])

  const [expense_voucher, setExpenseVoucher] = useState([])
  const [expense_voucher_sum, setExpenseVoucherSum] = useState([])
  const [expense_voucher_outstanding, setExpenseVoucherOutstanding] = useState([])

  const [payment_voucher, setPaymentVoucher] = useState([])
  const [payment_voucher_transfer, setPaymentVoucherTransfer] = useState([])
  const [payment_voucher_sum, setPaymentVoucherSum] = useState([])
  const [payment_voucher_outstanding, setPaymentVoucherOutstanding] = useState([])

  const [digital_payment, setDigitalPayment] = useState([])
  const [digital_payment_sum, setDigitalPaymentSum] = useState([])
  const [digital_payment_outstanding, setDigitalPaymentOutstanding] = useState([])

  const [non_fuel_purchase, setNonFuelPurchase] = useState([])
  const [non_fuel_purchase_sum, setNonFuelPurchaseSum] = useState([])
  const [non_fuel_purchase_discount_sum, setNonFuelPurchaseDiscountSum] = useState(0)
  const [non_fuel_purchase_outstanding, setNonFuelPurchaseOutstanding] = useState([])

  const [cylinder_purchase, setCylinderPurchase] = useState([])
  const [cylinder_purchase_sum, setCylinderPurchaseSum] = useState(0)
  const [cylinder_purchase_outstanding, setCylinderPurchaseOutstanding] = useState(0)

  const [short_excess, setShortExcess] = useState([])
  const [short_excess_sum, setShortExcessSum] = useState([])
  const [short_excess_outstanding, setShortExcessOutstanding] = useState([])

  const [fuel_purchase, setFuelPurchase] = useState([])
  const [fuel_purchase_sum, setFuelPurchaseSum] = useState([])
  const [fuel_purchase_outstanding, setFuelPurchaseOutstanding] = useState([])



  const [bank_transcation, setBankTranscation] = useState([])
  const [bank_transcation_sum, setBankTranscationSum] = useState([])
  const [bank_transcation_outstanding, setBankTranscationOutstanding] = useState([])
  const [closing_cash, setClosing] = useState([])
  const [closing_cash_dr_cr, setClosingDrCr] = useState({})
  const [exportingPdf, setExportingPdf] = useState(false)
  const [loadingReport, setLoadingReport] = useState(false)

  const [pump, setPump] = useState({})
  const [input, setInput] = useState({})
  const [show, setShow] = useState(false)





  const history = useHistory()
  const [state, setState] = useState([])
  const [all, setAll] = useState([])
  var buffer = ''; var flag = 0;

  useEffect(() => {


  }, [])
  const handleInput = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value
    });

  };
  const handleSubmit = (event) => {

    getDailySheet();
  }

  async function getDailySheet() {
    if (!inputValues.start_date || !inputValues.end_date) {
      swal("Please select start and end dates", "", "warning");
      return;
    }

    setLoadingReport(true);

    const requestOptions = {
      method: 'post',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
        "Accept": "application/json"

      },
      body: JSON.stringify({
        from_date: inputValues.start_date,
        to_date: inputValues.end_date,
        type: "1",
        summary: 2,
      })
    };
    fetch(API_URL + "/get_daily_transaction", requestOptions)
      .then(async (response) => {
        const responseData = await response.json();
        if (!response.ok || responseData.status === false) {
          throw new Error(responseData.message || "Unable to load daily transaction report.");
        }
        return responseData;
      })
      .then(responseData => {
        console.log(responseData)

        setOpeningBalance(responseData.opening_balance ?? '')
        setOpeningBalanceDrCr(responseData.opening_balance_dr_cr || {})

        setFuleSale(responseData.fuel_sales_detailed || [])
        setFuleSaleSum(responseData.fuel_sales_detailed_sum ?? 0)
        setFuleSaleOutstanding(responseData.fuel_sales_outstanding ?? 0)

        setLooseOil(responseData.loose_oil_sales_detailed || [])
        setLooseOilSum(responseData.loose_oil_sales_detailed_sum ?? 0)
        setLooseOilOutstanding(responseData.looseoil_outstanding ?? 0)

        setPakedOil(responseData.packed_oil_sales_detailed || [])
        setPakedOilSum(responseData.packed_oil_sales_detailed_sum ?? 0)
        setPakedOilOutstanding(responseData.packedoil_outstanding ?? 0)

        setCylinderSales(responseData.cylindersales_detailed || [])
        setCylinderSalesSum(responseData.total_sales?.cylinder_sales_detailed_sum || 0)
        setCylinderSalesOutstanding(responseData.outstanding?.cylinder_outstandings || 0)

        setLosSales(responseData.los_detailed || [])
        setLosSalesSum(responseData.total_sales?.twotsales_detailed_sum || 0)
        setLosSalesOutstanding(responseData.outstanding?.los_outstandings || 0)

        setReciept(responseData.reciept_voucher_detailed || [])
        setRecieptTransfer(responseData.reciept_account_transfer_detailed || [])
        setRecieptSalary(responseData.reciept_salary_detailed || [])
        setReceiptSum(responseData.reciept_voucher_deailed_sum ?? 0)
        setRecieptOutstanding(responseData.receipts_outstanding ?? 0)

        setCreditsales(responseData.credit_sales_detailed || [])
        setCreditSalesSum(responseData.credit_sales_detailed_sum ?? 0)
        setCreditsalesOutstanding(responseData.credit_sales_outstanding ?? 0)

        setFleetales(responseData.fleet_card_detailed || [])
        setFleetSalesSum(responseData.fleet_card_detailed_sum ?? 0)
        setFleetalesOutstanding(responseData.fleet_card_outstanding ?? 0)

        setRecoup(responseData.recoup_detailed || [])
        setRecoupSum(responseData.recoup_detailed_sum ?? 0)
        setRecoupOutsatanding(responseData.recoup_outstanding ?? 0)

        setMLASales(responseData.mla_coupon_detailed || [])
        setMLASalesSum(responseData.mla_coupon_detailed_sum ?? 0)
        setMLASalesOutstanding(responseData.mla_outstanding ?? 0)

        setExpenseVoucher(responseData.expense_voucher_detailed || [])
        setExpenseVoucherSum(responseData.expense_voucher_detailed_sum ?? 0)
        setExpenseVoucherOutstanding(responseData.expense_voucher_outstanding ?? 0)


        setPaymentVoucher(responseData.payment_voucher_detailed || [])
        setPaymentVoucherTransfer(responseData.payment_voucher_detailed_account_transfer || [])
        setPaymentVoucherSum(responseData.payment_voucher_detailed_sum ?? 0)
        setPaymentVoucherOutstanding(responseData.payment_voucher_outstanding ?? 0)



        setDigitalPayment(responseData.digital_payment_detailed || [])
        setDigitalPaymentSum(responseData.digital_payment_detailed_sum ?? 0)
        setDigitalPaymentOutstanding(responseData.card_digital_outstanding ?? 0)

        setNonFuelPurchase(responseData.non_fuel_purchase_detailed || [])
        setNonFuelPurchaseSum(responseData.non_fuel_purchase_detailed_sum ?? 0)
        setNonFuelPurchaseDiscountSum(responseData.total_sales?.non_fuel_purchase_discount_sum ?? 0)
        setNonFuelPurchaseOutstanding(responseData.non_fuel_purchase_outstanding ?? 0)

        setCylinderPurchase(responseData.cylinderpurchase_detailed || [])
        setCylinderPurchaseSum(responseData.total_sales?.cylinder_purchase_detailed_sum || 0)
        setCylinderPurchaseOutstanding(responseData.outstanding?.cyl_purchase_outstanding || 0)

        setShortExcess(responseData.short_excess_detailed || [])
        setShortExcessSum(responseData.short_excess_detailed_sum ?? 0)
        setShortExcessOutstanding(responseData.short_excess_outstanding ?? 0)

        setOtherIncome(responseData.other_income_detailed || [])
        setOtherIncomeSum(responseData.other_income_detailed_sum ?? 0)
        setOtherIncomeOutstanding(responseData.other_income_outstanding ?? 0)


        setBankTranscation(responseData.bank_transaction_detailed || [])
        setBankTranscationSum(responseData.bank_transaction_detailed_sum ?? 0)
        setBankTranscationOutstanding(responseData.bannk_transaction_outstanding ?? 0)

        setFuelPurchase(responseData.fule_purchase_transactions || [])
        setFuelPurchaseSum(responseData.fule_purchase_transactions_sum ?? 0)
        setFuelPurchaseOutstanding(responseData.fuel_purchase_outstanding ?? 0)

        setClosing(responseData.closing_cash ?? '')
        setClosingDrCr(responseData.closing_cash_dr_cr || {})

        var pump_name = responseData.pump_data?.[0]?.pump_name
        var pump_address = responseData.pump_data?.[0]?.pump_address
        setPump({
          ...pump,
          pump_name: pump_name,
          pump_address: pump_address

        })

        var start_date = responseData.start_date
        var end_date = responseData.end_date
        console.log(end_date)
        setInput({
          ...input,
          start_date: start_date,
          end_date: end_date

        })






      })
      .catch(e => {
        swal("Daily Transaction Report", e.message || "Something went wrong.", "error");
      })
      .finally(() => {
        setLoadingReport(false);
      });
  }
  function formatDisplayDate(value) {
    if (!value) return '';
    const parts = String(value).split('-');
    if (parts.length === 3) {
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }
    return value;
  }

  async function savesheet() {
    if (!inputValues.start_date || !inputValues.end_date) {
      swal('Please select start and end dates', '', 'warning');
      return;
    }
    setExportingPdf(true);
    try {
      const response = await fetch(API_URL + '/daily_transaction_export_pdf', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('AUTH_TOKEN'),
          Accept: 'application/json',
        },
        body: JSON.stringify({
          from_date: inputValues.start_date,
          to_date: inputValues.end_date,
          summary: 2,
        }),
      });
      const data = await response.json();
      if (!response.ok || data.status === false) {
        throw new Error(data.message || 'Unable to start PDF export.');
      }
      if (data.queued) {
        swal(
          'Export to PDF',
          data.message || 'PDF is generating. Open the download icon in the header when it is ready.',
          'success'
        );
      } else if (data.url) {
        window.open(data.url, '_blank');
        swal('Export to PDF', 'Your PDF is ready and downloading.', 'success');
      } else {
        swal(
          'Export to PDF',
          data.message || 'PDF is generating. Open the download icon in the header when it is ready.',
          'success'
        );
      }
    } catch (error) {
      swal('Export to PDF', error.message || 'Something went wrong.', 'error');
    } finally {
      setExportingPdf(false);
    }
  }
  const fuelSalesRows = useMemo(
    () => buildFuelSalesTableRows(fule_sale, opening_balance),
    [fule_sale, opening_balance]
  );
  const packedOilSalesRows = useMemo(
    () => buildPackedOilSalesTableRows(paked_oil),
    [paked_oil]
  );
  const cylinderSalesRows = useMemo(
    () => buildCylinderSalesTableRows(cylinder_sales),
    [cylinder_sales]
  );
  const oilBarrelSalesRows = useMemo(
    () => buildOilBarrelSalesTableRows(los_sales),
    [los_sales]
  );
  const creditSalesRows = useMemo(
    () => buildCreditSalesTableRows(credit_sales),
    [credit_sales]
  );
  const recoupRows = useMemo(
    () => buildRecoupTableRows(recoup),
    [recoup]
  );
  const expenseVoucherRows = useMemo(
    () => buildExpenseVoucherTableRows(expense_voucher),
    [expense_voucher]
  );
  const digitalPaymentRows = useMemo(
    () => buildDigitalPaymentTableRows(digital_payment),
    [digital_payment]
  );
  const shortExcessRows = useMemo(
    () => buildShortExcessTableRows(short_excess),
    [short_excess]
  );
  const shortExcessGrandTotal = useMemo(
    () => computeShortExcessGrandTotal(short_excess),
    [short_excess]
  );

  return (

    <>

      <div className="main-container page-wrap">
        <div className="d-md-flex">
          <Sidebar_Progress props={props} progress={14} operation={3} op={3} />
          <div className="content-area">
            <LoginHeaderOperational props={props} page_title="  " />

            {

            }

            <div className="container pb-3">
              <OtherReportFilterCard
                title="Daily transaction parameters"
                description="Select the date range and run the detailed daily transaction sheet."
                className="daily-transaction-filter-card"
              >
                <OtherReportToolbar
                  actionsWide
                  dates={(
                    <ReportDateRangeFields
                      startDate={inputValues.start_date}
                      endDate={inputValues.end_date}
                      onChange={({ start_date, end_date }) => setInputValues({
                        ...inputValues,
                        start_date,
                        end_date,
                      })}
                    />
                  )}
                  actions={(
                    <div className="daily-transaction-toolbar-actions">
                      <ReportSubmitButton loading={loadingReport} onClick={handleSubmit} />
                      <DailyTransactionWacPanel
                        fromDate={inputValues.start_date}
                        toDate={inputValues.end_date}
                        disabled={!inputValues.start_date || !inputValues.end_date || loadingReport}
                        onApplied={getDailySheet}
                        buttonClassName="other-report-btn other-report-btn-secondary"
                      />
                      <button
                        type="button"
                        className="other-report-btn other-report-btn-secondary"
                        onClick={() => history.push('/daily-transaction-summary')}
                      >
                        Daily Summary
                      </button>
                      <button
                        type="button"
                        className="other-report-btn other-report-btn-secondary"
                        onClick={savesheet}
                        disabled={exportingPdf || !inputValues.start_date || !inputValues.end_date}
                      >
                        {exportingPdf ? 'Exporting…' : 'Export PDF'}
                      </button>
                    </div>
                  )}
                />
              </OtherReportFilterCard>

              {loadingReport && (
                <div className="daily-transaction-report-loading" role="status" aria-live="polite">
                  <div className="spinner-border text-primary" />
                  <span>Loading daily transaction report…</span>
                </div>
              )}

              <div className="row justify-content-center">
                <div className="col-md-12">

                  <div className="form-wrap balace-sheetwrap">

                    <div className="row mb-3">
                      <div className="col-md ">
                        <h2 className="table-title  mb-1">{pump.pump_name ? pump.pump_name : "COMPANY NAME"}</h2>
                        <h4 className="table-title mb-1">Daily Transaction Sheet Detailed</h4>
                        <h5>{input.start_date ? <>{formatDisplayDate(input.start_date)} -- {formatDisplayDate(input.end_date)}</> : 'DATE'}</h5>
                        <img src={logo} className="img-fluid float-end " width="100px" />
                      </div>
                    </div>






                    <div className="table-widget">
                      <table className="table border">
                        <thead>
                          <tr class="border">
                            <th>Opening balance</th>
                            <th className="report-amount-header">Debit(RS)</th>
                            <th className="report-amount-header">Credit(RS)</th>
                            <th className="report-amount-header">Outstanding(RS)</th>
                          </tr>

                        </thead>
                        <tbody>
                          <tr>
                            <NumTd value={opening_balance} />
                            <NumTd value={opening_balance_dr_cr?.dr_amount || ''} />
                            <NumTd value={opening_balance_dr_cr?.cr_amount || ''} />
                            <NumTd value={opening_balance_dr_cr?.outstanding || opening_balance} />
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="table-widget daily-transaction-section">
                      <h3 className="table-title text-start" >Fuel Sales</h3>
                      <div className="daily-transaction-table-wrap">
                      <table className="daily-transaction-scroll-table table border">

                        <thead>
                          <tr class="border">
                            <th>Date</th>
                            <th class="">Product Name</th>
                            <th>Employee Name</th>
                            <th>Nozzle Name</th>
                            <th>Start From</th>
                            <th>End From</th>
                            <th>Opening Reading </th>
                            <th>Closing Reading</th>
                            <th>Quantity</th>
                            <th>Recoup Qty</th>
                            <th>Net Qty</th>
                            <th>Sales Price</th>
                            <th>Debit(RS)</th>
                            <th>Credit(RS)</th>
                            <th>Net Sales</th>
                            <th>Outstanding(RS)</th>
                          </tr>
                        </thead>

                        <tbody>
                          {fuelSalesRows.bodyRows.map((row, index) => {
                            if (row.type === 'subtotal') {
                              return (
                                <tr key={`fuel-subtotal-${index}`} className="daily-transaction-fuel-subtotal">
                                  <td colSpan="2"></td>
                                  <td colSpan="6"></td>
                                  <NumTd value={row.quantitySum} />
                                  <NumTd value={row.recoupQtySum || ''} />
                                  <NumTd value={row.netQtySum} />
                                  <td></td>
                                  <NumTd value={row.debitTotal} />
                                  <NumTd value={row.recoupAmountTotal || ''} />
                                  <td></td>
                                  <NumTd value={row.outstanding} />
                                </tr>
                              );
                            }

                            return (
                              <tr key={row.key || `fuel-row-${index}`}>
                                <td>{row.opDate}</td>
                                <td><FuelLabel name={row.fuelName} /></td>
                                <td>{row.empName}</td>
                                <td>{row.nozzleName}</td>
                                <td>{row.startFrom}</td>
                                <td>{row.endFrom}</td>
                                <NumTd value={row.openingReading} />
                                <NumTd value={row.closeReading} />
                                <NumTd value={row.quantity} />
                                <NumTd value={row.recoupQty || ''} />
                                <NumTd value={row.netQty} />
                                <NumTd value={row.price} />
                                <NumTd value={row.debitAmount} />
                                <NumTd value={row.recoupAmount || ''} />
                                <NumTd value={row.netSales} />
                                <NumTd value={row.outstanding} />
                              </tr>
                            );
                          })}

                          <tr class="">
                            <td colSpan="12"></td>
                            <td>Total Fuel Sale </td>
                            <NumTd value={fule_sale_sum} />
                            <td></td>
                            <NumTd value={fule_sale_outstanding} />
                          </tr>

                        </tbody>
                      </table>
                      </div>
                    </div>



                    <div className="table-widget">
                      <h1 class="table-title text-start">Loose Oil Sales</h1>
                      <table className="table border">

                        <thead>
                          <tr>
                            <th>Product Name</th>
                            <th >Quantity</th>
                            <th >Price</th>
                            <th ></th>
                            <th >Debit(RS)</th>
                            <th>Credit(RS)</th>
                            <th>Outstanding(RS)</th>




                          </tr>
                        </thead>

                        <tbody>
                          {
                            Loose_oil.map((obj) => (

                              <tr>
                                <td>{obj.product_name}</td>
                                <NumTd value={obj.quantity} />
                                <NumTd value={obj.selling_price} />
                                <td></td>

                                <NumTd value={obj.dr_amount} />
                                <NumTd value={obj.cr_amount} />
                                <td></td>



                              </tr>

                            ))}

                          <tr >

                            <td></td>
                            <td></td>
                            <td></td>
                            <td>Product Wise sub Total</td>
                            <td></td>
                            <td></td>
                            <td></td>




                          </tr>
                          <tr >
                            <td></td>
                            <td></td>
                            <td></td>
                            <td > Total Loose Oil Sales </td>
                            <NumTd value={Loose_oil_sum} />
                            <td></td>
                            <td>{Loose_oil__outstanding}</td>

                          </tr>

                        </tbody>
                      </table>
                    </div>


                    <div className="table-widget">

                      <h3 className="table-title text-start" >Packed Oil  and Other Sales</h3>
                      <table className="table border">
                        <thead>
                          <tr class="border">
                            <th>Product Name</th>
                            <th>Customer Name</th>
                            <th>Quantity</th>
                            <th>Price</th>
                            <th>Discount(RS)</th>
                            <th>Debit(RS)</th>
                            <th>Credit(RS)</th>
                            <th>Outstanding(RS)</th>
                          </tr>
                        </thead>

                        <tbody>
                          {packedOilSalesRows.bodyRows.map((row, index) => {
                            if (row.type === 'subtotal') {
                              return (
                                <tr key={`packed-subtotal-${index}`} className="daily-transaction-product-subtotal border">
                                  <td></td>
                                  <td>{row.productName} sub Total</td>
                                  <NumTd value={row.quantitySum} />
                                  <td></td>
                                  <NumTd value={row.discountSum} />
                                  <NumTd value={row.debitTotal} />
                                  <NumTd value={row.creditTotal} />
                                  <td></td>
                                </tr>
                              );
                            }

                            return (
                              <tr key={row.key || `packed-row-${index}`} class="border">
                                <td>{row.productName}</td>
                                <td>{row.customerName}</td>
                                <NumTd value={row.quantity} />
                                <NumTd value={row.sellingPrice} />
                                <NumTd value={row.discountAmount || ''} />
                                <NumTd value={row.debitAmount} />
                                <NumTd value={row.creditAmount} />
                                <td></td>
                              </tr>
                            );
                          })}

                          <tr class="border daily-transaction-product-subtotal">
                            <td colSpan="3"></td>
                            <td>Total Packed Oil  and Other Sales </td>
                            <td></td>
                            <NumTd value={paked_oil_sum} />
                            <td></td>
                            <NumTd value={paked_oil_outstanding} />
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="table-widget">
                      <h3 className="table-title text-start">Cylinder Sales</h3>
                      <table className="table border">
                        <thead>
                          <tr class="border">
                            <th>Product Name</th>
                            <th>Customer Name</th>
                            <th>Quantity</th>
                            <th>Price</th>
                            <th>Debit(RS)</th>
                            <th>Credit(RS)</th>
                            <th>Outstanding(RS)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {cylinderSalesRows.bodyRows.map((row, index) => {
                            if (row.type === 'subtotal') {
                              return (
                                <tr key={`cyl-subtotal-${index}`} className="daily-transaction-product-subtotal border">
                                  <td></td>
                                  <td></td>
                                  <td>{row.groupLabel} sub Total</td>
                                  <NumTd value={row.amountSum} />
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              );
                            }

                            return (
                              <tr key={row.key || `cyl-row-${index}`} class="border">
                                <td>{row.productName}</td>
                                <td>{row.customerName}</td>
                                <NumTd value={row.qty} />
                                <NumTd value={row.salesPrice} />
                                <NumTd value={row.debitAmount} />
                                <NumTd value={row.creditAmount} />
                                <td></td>
                              </tr>
                            );
                          })}
                          <tr class="border daily-transaction-product-subtotal">
                            <td colSpan="2"></td>
                            <td>Total Cylinder Sales</td>
                            <td></td>
                            <td></td>
                            <NumTd value={cylinder_sales_sum} />
                            <NumTd value={cylinder_sales_outstanding} />
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="table-widget">
                      <h3 className="table-title text-start">Oil Barrel Sales</h3>
                      <table className="table border">
                        <thead>
                          <tr class="border">
                            <th>Product Name</th>
                            <th>Customer Name</th>
                            <th>Full Barrel Qty</th>
                            <th>Loose Barrel Qty</th>
                            <th>Full Barrel MRP</th>
                            <th>Loose Barrel MRP</th>
                            <th>Machine sales</th>
                            <th>Debit(RS)</th>
                            <th>Credit(RS)</th>
                            <th>Outstanding(RS)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {oilBarrelSalesRows.bodyRows.map((row, index) => {
                            if (row.type === 'subtotal') {
                              return (
                                <tr key={`los-subtotal-${index}`} className="daily-transaction-product-subtotal border">
                                  <td colSpan="6"></td>
                                  <td>{row.groupLabel} sub Total</td>
                                  <NumTd value={row.amountSum} />
                                  <td></td>
                                  <td></td>
                                </tr>
                              );
                            }

                            return (
                              <tr key={row.key || `los-row-${index}`} class="border">
                                <td>{row.productName}</td>
                                <td>{row.customerName}</td>
                                <NumTd value={row.fullBarrelQty} />
                                <NumTd value={row.looseBarrelQty} />
                                <NumTd value={row.fullBarrelMrp} />
                                <NumTd value={row.looseBarrelMrp} />
                                <NumTd value={row.machineSales} />
                                <NumTd value={row.debitAmount} />
                                <NumTd value={row.creditAmount} />
                                <td></td>
                              </tr>
                            );
                          })}
                          <tr class="border daily-transaction-product-subtotal">
                            <td colSpan="7"></td>
                            <td>Total Oil Barrel Sales</td>
                            <NumTd value={los_sales_sum} />
                            <NumTd value={los_sales_outstanding} />
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="table-widget">
                      <h3 className="table-title text-start" >Receipts </h3>
                      <table class="table border ">
                        <thead>
                          <tr >
                            <th>Party Name </th>
                            <th>A/C Category</th>
                            <th>A/C Sub Category</th>
                            <th>System Voucher Number</th>
                            <th>Voucher Number</th>
                            <th>Description</th>

                            <th></th>
                            <th>Debit(RS)</th>
                            <th>Credit(RS)</th>
                            <th>Outstanding(RS)</th>


                          </tr>

                        </thead>
                        <tbody>
                          {
                            reciept.map((obj) => (

                              <tr class="border">
                                <td>{obj.name}</td>
                                <td>{obj.category}</td>
                                <td>{obj.ac_name_slug}</td>
                                <td>{obj.sys_voucher_no}</td>
                                <td>{obj.voucher_no}</td>
                                <td>{obj.note}</td>
                                <td></td>

                                <NumTd value={obj.amount} />
                                <NumTd value={obj.cr_amount} />
                                <td></td>

                              </tr>

                            ))}

                          {
                            reciept_transfer.map((obj, index) => (
                              <tr key={'rcpt-tr-' + index} class="border">
                                <td>{obj.ac_name_slug}</td>
                                <td>{obj.category}</td>
                                <td>{obj.sub_cat}</td>
                                <td>{obj.sys_voucher_no}</td>
                                <td>{obj.voucher_no}</td>
                                <td>{obj.note}</td>
                                <td></td>
                                <NumTd value={obj.amount} />
                                <NumTd value={obj.cr_amount} />
                                <td></td>
                              </tr>
                            ))}

                          {
                            reciept_salary.map((obj, index) => (
                              <tr key={'rcpt-sal-' + index} class="border">
                                <td>{obj.ac_name_slug}</td>
                                <td>{obj.category}</td>
                                <td>{obj.sub_cat}</td>
                                <td></td>
                                <td></td>
                                <td>{obj.note}</td>
                                <td></td>
                                <NumTd value={obj.amount} />
                                <td></td>
                                <td></td>
                              </tr>
                            ))}

                          <tr class="border">

                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>



                            <td>Product Wise sub Total</td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr class="border">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>

                            <td>Total Receipts</td>
                            <td>  {receipt_sum}</td>
                            <td></td>
                            <NumTd value={reciept_outstanding} />

                          </tr>

                        </tbody>
                      </table>
                    </div>

                    <div className="table-widget">

                      <h3 className="table-title text-start" >Other Income</h3>
                      <table className="table border">
                        <thead>
                          <tr class="border">
                            <th>Account  Name</th>
                            <th>Income Sub Head</th>
                            <th> System Voucher Number </th>
                            <th>Payment Voucher Number</th>
                            <th>Description</th>
                            <th></th>
                            <th>Debit(RS)</th>
                            <th>Credit(RS)</th>
                            <th>Outstanding(RS)</th>

                          </tr>

                        </thead>
                        <tbody>
                          {
                            other_income.map((obj) => (

                              <tr class="border">
                                <td>{obj.name}</td>
                                <td>{obj.ac_name_slug}</td>
                                <td>{obj.sys_voucher_no}</td>
                                <td>{obj.voucher_no}</td>
                                <td>{obj.note}</td>
                                <td></td>

                                <NumTd value={obj.amount} />
                                <NumTd value={obj.cr_amount} />
                                <td></td>



                              </tr>

                            ))}

                          <tr class="border">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>Product Wise sub Total</td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr class="border">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>Total Other Income</td>
                            <NumTd value={other_income_sum} />
                            <td></td>
                            <NumTd value={other_income_outstanding} />
                          </tr>

                        </tbody>
                      </table>
                    </div>

                    <div class="table-widget">
                      <h3 className="table-title text-start" >Credit Sales </h3>


                      <table class="border table">
                        <thead>
                          <tr class="border">
                            <th>Coustmer Name </th>
                            <th>Intent Number</th>
                            <th>Vechile number</th>
                            <th> Product </th>
                            <th> Quantity</th>
                            <th>Price</th>
                            <th>Description</th>
                            <th></th>
                            <th>Debit(RS)</th>
                            <th>Credit(RS)</th>
                            <th>Outstanding(RS)</th>




                          </tr>

                        </thead>
                        <tbody>
                          {creditSalesRows.bodyRows.map((row, index) => {
                            if (row.type === 'subtotal') {
                              return (
                                <tr key={`credit-subtotal-${index}`} className="daily-transaction-product-subtotal border">
                                  <td colSpan="7"></td>
                                  <td>{row.groupLabel} sub Total</td>
                                  <NumTd value={row.amountSum} />
                                  <td></td>
                                </tr>
                              );
                            }

                            return (
                              <tr key={row.key || `credit-row-${index}`} class="border">
                                <td>{row.customerName}</td>
                                <td>{row.intentNo}</td>
                                <td>{row.vehicleNo}</td>
                                <td><FuelLabel name={row.fuelName} /></td>
                                <NumTd value={row.quantity} />
                                <NumTd value={row.price} />
                                <td>{row.note}</td>
                                <td></td>
                                <td></td>
                                <NumTd value={row.amount} />
                                <td></td>
                              </tr>
                            );
                          })}
                          <tr class="border daily-transaction-product-subtotal">
                            <td colSpan="7"></td>
                            <td>Total Credit Sales</td>
                            <NumTd value={credit_sales_sum} />
                            <td></td>
                            <NumTd value={credit_sales_outstanding} />
                          </tr>
                        </tbody>

                      </table>
                    </div>

                    <div class="table-widget">

                      <h3 className="table-title text-start" >Recoup</h3>
                      <table class="table border">
                        <thead>
                          <tr class="border">
                            <th>Product Name </th>
                            <th>Recoup Tank</th>
                            <th>Quantitiy</th>
                            <th>Price</th>
                            <th>Description</th>
                            <th>Debit</th>
                            <th>Credit</th>
                            <th>OutStanding</th>
                          </tr>
                        </thead>
                        <tbody>
                          {recoupRows.bodyRows.map((row, index) => {
                            if (row.type === 'subtotal') {
                              return (
                                <tr key={`recoup-subtotal-${index}`} className="daily-transaction-product-subtotal border">
                                  <td></td>
                                  <td>{`Total ${row.groupLabel} quantity:`}</td>
                                  <NumTd value={row.quantitySum} />
                                  <td></td>
                                  <td>{`${row.groupLabel} sub Total`}</td>
                                  <NumTd value={row.amountSum} />
                                  <td></td>
                                  <td></td>
                                </tr>
                              );
                            }

                            return (
                              <tr key={row.key || `recoup-row-${index}`} class="border">
                                <td><FuelLabel name={row.fuelName} /></td>
                                <td>{row.tankName}</td>
                                <NumTd value={row.quantity} />
                                <NumTd value={row.price} />
                                <td>{row.note}</td>
                                <NumTd value={row.debitAmount} />
                                <NumTd value={row.creditAmount} />
                                <td></td>
                              </tr>
                            );
                          })}
                          <tr class="border daily-transaction-product-subtotal">
                            <td colSpan="4"></td>
                            <td>Total Recoup Amount</td>
                            <NumTd value={recoup_sum} />
                            <td></td>
                            <NumTd value={recoup_outstanding} />
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="table-widget">
                      <h3 className="table-title text-start" >MLA Coupon </h3>
                      <table class="table border">
                        <thead>
                          <tr class="border">
                            <th>Issue Date </th>
                            <th>Coupon Number</th>
                            <th>Expiry Date</th>
                            <th>Product </th>
                            <th>Quantity</th>
                            <th>Price</th>
                            <th>Description</th>
                            <th></th>
                            <th>Debit(RS)</th>
                            <th>Credit(RS)</th>
                            <th>Outstanding(RS)</th>
                          </tr>

                        </thead>
                        <tbody>
                          {
                            mla_sales.map((obj) => (

                              <tr>
                                <td>{obj.issue_date}</td>
                                <td>{obj.coupon_no}</td>
                                <td>{obj.expiry_date}</td>
                                <td><FuelLabel name={obj.fuel_name} /></td>
                                <NumTd value={obj.quantity} />
                                <td>{obj.price}</td>
                                <td>{obj.note}</td>
                                <td></td>

                                <NumTd value={obj.dr_amount} />
                                <NumTd value={obj.amount} />
                                <td></td>


                              </tr>

                            ))}
                          < tr class="border">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>

                            <td>Product Wise sub Total</td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr class="border">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>

                            <td>Total MLA Coupon </td>
                            <NumTd value={mla_sales_sum} />
                            <td></td>
                            <NumTd value={mla_sales_outstanding} />
                          </tr>

                        </tbody>

                      </table>

                    </div>

                    <div class="table-widget">
                      <h3 className="table-title text-start" >Fleet card sales </h3>
                      <table class="table border">
                        <thead>
                          <tr class="border">
                            <th>card Number </th>
                            <th>Product</th>
                            <th>Quantity</th>
                            <th>Price</th>
                            <th>Description</th>
                            <th></th>
                            <th>Debit(RS)</th>
                            <th>Credit(RS)</th>
                            <th>Outstanding(RS)</th>
                          </tr>

                        </thead>
                        <tbody>
                          {
                            fleet_sales.map((obj) => (

                              <tr class="border">
                                <td>{obj.card_no}</td>
                                <td><FuelLabel name={obj.fuel_name} /></td>

                                <NumTd value={obj.quantity} />
                                <td>{obj.price}</td>
                                <td>{obj.note}</td>
                                <td></td>

                                <NumTd value={obj.dr_amount} />
                                <NumTd value={obj.amount} />
                                <td></td>

                              </tr>

                            ))}
                          < tr class="border">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>


                            <td>Product Wise sub Total</td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr class="border">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>

                            <td>Total fleet card sales</td>
                            <NumTd value={fleet_sales_sum} />
                            <td></td>
                            <NumTd value={fleet_sales_outstanding} />

                          </tr>

                        </tbody>

                      </table>
                    </div>

                    <div class="table-widget">
                      <h3 className="table-title text-start" >Expense Voucher</h3>
                      <table class="table border">
                        <thead>
                          <tr class="border">
                            <th>Party Name</th>
                            <th>Account Name</th>
                            <th>System voucher Number</th>
                            <th>Voucher Number</th>
                            <th>Expense Category </th>
                            <th>Expense Sub Category</th>
                            <th>Description</th>

                            <th></th>
                            <th>Debit(RS)</th>
                            <th>Credit(RS)</th>
                            <th>Outstanding(RS)</th>


                          </tr>

                        </thead>
                        <tbody>
                          {expenseVoucherRows.bodyRows.map((row, index) => {
                            if (row.type === 'subtotal') {
                              return (
                                <tr key={`expense-subtotal-${index}`} className="daily-transaction-product-subtotal border">
                                  <td colSpan="7"></td>
                                  <td>{row.groupLabel} sub Total</td>
                                  <td></td>
                                  <NumTd value={row.amountSum} />
                                  <td></td>
                                </tr>
                              );
                            }

                            return (
                              <tr key={row.key || `expense-row-${index}`} class="border">
                                <td>{row.partyName}</td>
                                <td>{row.accountName}</td>
                                <td>{row.sysVoucherNo}</td>
                                <td>{row.voucherNo}</td>
                                <td>{row.category}</td>
                                <td>{row.subCategory}</td>
                                <td>{row.note}</td>
                                <td></td>
                                <td></td>
                                <NumTd value={row.amount} />
                                <td></td>
                              </tr>
                            );
                          })}
                          <tr class="border daily-transaction-product-subtotal">
                            <td colSpan="7"></td>
                            <td>Total Expense Vouchers</td>
                            <td></td>
                            <NumTd value={expense_voucher_sum} />
                            <NumTd value={expense_voucher_outstanding} />
                          </tr>
                        </tbody>

                      </table>

                    </div>
                    <div class="table-widget">

                      <h1 className="table-title text-start" >Payment Voucher</h1>

                      <table class="table border">
                        <thead>
                          <tr class="border">
                            <th>Party Name</th>
                            <th>System Vocuher</th>
                            <th>Vocuher Number</th>
                            <th>A/c Category</th>
                            <th>A/c Sub Category</th>
                            <th>Descriptinon</th>

                            <th></th>
                            <th>Debit(RS)</th>
                            <th>Credit(RS)</th>
                            <th>Outstanding(RS)</th>


                          </tr>

                        </thead>
                        <tbody>
                          {
                            payment_voucher.map((obj) => (

                              <tr class="border">
                                <td>{obj.name}</td>
                                <td>{obj.sys_voucher_no}</td>
                                <td>{obj.voucher_no}</td>

                                <td>{obj.category}</td>
                                <td>{obj.ac_name_slug}</td>
                                <td>{obj.note}</td>
                                <td></td>

                                <NumTd value={obj.dr_amount} />
                                <NumTd value={obj.amount} />
                                <td></td>

                                {/* <NumTd value={obj.amount} /> */}
                              </tr>

                            ))}

                          {
                            payment_voucher_transfer.map((obj, index) => (
                              <tr key={'pay-tr-' + index} class="border">
                                <td>{obj.ac_name_slug}</td>
                                <td>{obj.sys_voucher_no}</td>
                                <td>{obj.voucher_no}</td>
                                <td>{obj.category}</td>
                                <td>{obj.sub_cat}</td>
                                <td>{obj.note}</td>
                                <td></td>
                                <td></td>
                                <NumTd value={obj.amount} />
                                <td></td>
                              </tr>
                            ))}
                          < tr class="border">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>



                            <td>Product Wise sub Total</td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr class="border">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>


                            <td> Total Payment Voucher </td>
                            <NumTd value={payment_voucher_sum} />
                            <td></td>
                            <NumTd value={payment_voucher_outstanding} />


                          </tr>

                        </tbody>

                      </table>
                    </div>


                    <div class="table-widget">
                      <h3 className="table-title text-start" >Card/Digital Payment</h3>
                      <table class="border table">
                        <thead>
                          <tr>
                            <th>Payment Type</th>
                            <th>Bank Name </th>

                            <th>Card Number </th>
                            <th>Description</th>
                            {/* <th>Quantity</th> */}
                            <th></th>
                            <th>Debit(RS)</th>
                            <th>Credit(RS)</th>
                            <th>Outstanding(RS)</th>
                          </tr>

                        </thead>
                        <tbody>
                          {digitalPaymentRows.bodyRows.map((row, index) => {
                            if (row.type === 'subtotal') {
                              return (
                                <tr key={`digital-subtotal-${index}`} className="daily-transaction-product-subtotal border">
                                  <td colSpan="5">{row.groupLabel} sub Total</td>
                                  <td></td>
                                  <td></td>
                                  <NumTd value={row.amountSum} />
                                </tr>
                              );
                            }

                            return (
                              <tr key={row.key || `digital-row-${index}`} className="border">
                                <td>{row.methodName}</td>
                                <td>{row.bankName}</td>
                                <td>{row.cardNo}</td>
                                <td>{row.note}</td>
                                <td></td>
                                <NumTd value={row.debitAmount} />
                                <NumTd value={row.creditAmount} />
                                <td></td>
                              </tr>
                            );
                          })}
                          <tr className="border daily-transaction-product-subtotal">
                            <td colSpan="5">Total Card/Digital Payment</td>
                            <td></td>
                            <td></td>
                            <NumTd value={digital_payment_sum} />
                          </tr>

                        </tbody>

                      </table>
                    </div>


                    <div class="table-widget">
                      <h3 className="table-title text-start" >Short/Excess</h3>
                      <table class="border table">
                        <thead>
                          <tr class="border">
                            <th>Employee Name</th>
                            <th>Short Amount</th>
                            <th>Excess Amount</th>
                            <th>Short/Excess</th>
                            <th>Debit(RS)</th>
                            <th>Credit(RS)</th>
                            <th>Outstanding(RS)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {shortExcessRows.bodyRows.map((row, index) => {
                            if (row.type === 'subtotal') {
                              return (
                                <tr key={`short-subtotal-${index}`} className="daily-transaction-product-subtotal border">
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td>{row.groupLabel} Sub Total</td>
                                  <NumTd value={row.netAmount} />
                                  <td></td>
                                  <td></td>
                                </tr>
                              );
                            }

                            return (
                              <tr key={row.key || `short-row-${index}`} class="border">
                                <td>{row.employeeName}</td>
                                <NumTd value={row.shortAmount || ''} />
                                <NumTd value={row.excessAmount || ''} />
                                <td>{row.shortExcessLabel}</td>
                                <NumTd value={row.debitAmount || ''} />
                                <NumTd value={row.creditAmount || ''} />
                                <td></td>
                              </tr>
                            );
                          })}
                          <tr class="border daily-transaction-product-subtotal">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>Total Short/Excess</td>
                            <NumTd value={shortExcessGrandTotal} />
                            <td></td>
                            <NumTd value={short_excess_outstanding} />
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="table-widget">

                      <h3 className="table-title text-start" >Bank Transactions</h3>
                      <table class="border table">
                        <thead>
                          <tr class="border">
                            <th>Transcation Type</th>
                            <th>Bank Name</th>
                            <th>Descripition</th>
                            <th>Party/Account Reference</th>
                            <th>Cheque Number</th>
                            <th></th>


                            <th>Debit(RS)</th>
                            <th>Credit(RS)</th>
                            <th>Outstanding(RS)</th>


                          </tr>

                        </thead>
                        <tbody>
                          {
                            bank_transcation.map((obj) => (

                              <tr>
                                <td>{obj.transaction_type}</td>
                                <td>{obj.bank_name}</td>
                                <td>{obj.note}</td>

                                <td>{obj.partyorreference}</td>
                                <td>{obj.cheque_no}</td>
                                <td></td>

                                <NumTd value={obj.dr_amount} />
                                <NumTd value={obj.cr_amount} />
                                <td></td>

                              </tr>

                            ))}
                          < tr class="border">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>



                            <td> sub Total </td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr class="border">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>


                            <td>Total  Bank Transactions </td>
                            <NumTd value={bank_transcation_sum} />
                            <td></td>
                            <NumTd value={bank_transcation_outstanding} />

                          </tr>

                        </tbody>

                      </table>

                    </div>


                    <div class="table-widget">

                      <h3 className="table-title text-start">Non Fuel Purchase Transaction</h3>
                      <table class="table border">
                        <thead>
                          <tr class="border">
                            <th>Product Name</th>
                            <th>Quantity</th>
                            <th>Invoice Number</th>
                            <th>Vendor Name</th>
                            <th>Discount(RS)</th>
                            <th>Debit(RS)</th>
                            <th>Credit(RS)</th>
                            <th>Outstanding(RS)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {non_fuel_purchase.map((obj, index) => (
                            <tr key={`nf-purchase-${index}`} class="border">
                              <td>{obj.product_name}</td>
                              <NumTd value={obj.quantity} />
                              <td>{obj.invoice_number}</td>
                              <td>{obj.vendor_name || obj.name}</td>
                              <NumTd value={obj.discount || ''} />
                              <NumTd value={obj.dr_amount || ''} />
                              <NumTd value={obj.cr_amount || obj.amount} />
                              <td></td>
                            </tr>
                          ))}
                          <tr class="border daily-transaction-product-subtotal">
                            <td colSpan="3"></td>
                            <td>Total Non - Fuel Purchases</td>
                            <NumTd value={non_fuel_purchase_discount_sum} />
                            <td></td>
                            <NumTd value={non_fuel_purchase_sum} />
                            <NumTd value={non_fuel_purchase_outstanding} />
                          </tr>
                        </tbody>
                      </table>

                    </div>

                    <div className="table-widget">
                      <h3 className="table-title text-start">Cylinder Purchase Transaction</h3>
                      <table className="table border">
                        <thead>
                          <tr class="border">
                            <th>Product Name</th>
                            <th>Quantity</th>
                            <th>Invoice Number</th>
                            <th>Vendor Name</th>
                            <th>Customer Name</th>
                            <th>Debit(RS)</th>
                            <th>Credit(RS)</th>
                            <th>Outstanding(RS)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {cylinder_purchase.map((obj, index) => (
                            <tr key={'cylp-' + index} class="border">
                              <td>{obj.product_name}</td>
                              <NumTd value={obj.quantity} />
                              <td>{obj.invoice_number}</td>
                              <td>{obj.name}</td>
                              <td>{obj.cust_name}</td>
                              <td></td>
                              <NumTd value={obj.amount} />
                              <td></td>
                            </tr>
                          ))}
                          <tr class="border daily-transaction-product-subtotal">
                            <td colSpan="4"></td>
                            <td>Total Cylinder Purchases</td>
                            <td></td>
                            <NumTd value={cylinder_purchase_sum} />
                            <NumTd value={cylinder_purchase_outstanding} />
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="table-widget">
                      <table className="table border">
                        <thead>
                          <tr class="border">
                            <th>Closing Cash</th>
                            <th>Debit(RS)</th>
                            <th>Credit(RS)</th>
                            <th>Outstanding(RS)</th>
                          </tr>

                        </thead>
                        <tbody>
                          <tr>
                            <NumTd value={closing_cash} />
                            <NumTd value={closing_cash_dr_cr?.dr_amount || ''} />
                            <NumTd value={closing_cash_dr_cr?.cr_amount || ''} />
                            <NumTd value={closing_cash_dr_cr?.outstanding || closing_cash} />
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="table-widget">






                      <h1 className="table-title text-start" >Other Information</h1>
                      <h3 className="table-title text-start" >Fuel Purchase Transaction</h3>

                      <table class="table border">
                        <thead>
                          <tr class="border">
                            <th>Product Name</th>
                            <th>Quantity</th>
                            <th>Purchase Price</th>
                            <th>Vendor Name</th>
                            <th>Invoice Number</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {fuel_purchase.map((obj, index) => (
                            <tr key={`fuel-purchase-${index}`} class="border">
                              <td><FuelLabel name={obj.fuel_name} /></td>
                              <NumTd value={obj.quantity} />
                              <NumTd value={obj.purchase_price} />
                              <td>{obj.dealer_name}</td>
                              <td>{obj.invoice_no}</td>
                              <NumTd value={obj.amount} />
                            </tr>
                          ))}
                          <tr class="border daily-transaction-product-subtotal">
                            <td colSpan="4"></td>
                            <td>Total Fuel Purchases</td>
                            <NumTd value={fuel_purchase_sum} />
                          </tr>
                        </tbody>
                      </table>

                    </div>

                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>

      </div>


    </>
  )
}


export default DailyTransactionSheet